import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'
import classNames from 'classnames'

class Sidebar extends Component {

  constructor(props) {
    super(props)

  }

  renderSubMenu(sections, order, staticVersion) {
    if(sections.length > 0){
      return (<li className={'grid--order-' + order}>
                <ul className={'nav__submenu flush'}>
                  {sections.map(function(object, i){
                     if (staticVersion === false || object.includeStatic !== false) {
                       return (
                         <li key={object.anchor}><a className="clearfix" href={object.anchor}>{object.name}
                           {(() => {
                             if (object.js){
                               return <code className="float--right">JS</code>
                             }
                           })()}
                         </a></li>
                       )
                     }
                  })}
                </ul>
              </li>)
    }
    return;
  }

  render (){
    const { sections, selected } = this.props
    let order = 12;
    switch (selected) {
      case 'Home':
          order = 1;
          break;
      case 'Brand':
          order = 3;
          break;
      case 'Core':
          order = 5;
          break;
      case 'Components':
          order = 7;
          break;
      case 'Layouts':
          order = 9;
          break;
      case 'Themes':
          order = 9;
          break;
      case 'GettingStarted':
          order = 11;
          break;
    }

    return(
      <nav className="sidebar js-home hide" id="menu">

        <ul className="nav--branded-main grid grid--direction-column">
          <li className="grid--order-0 visuallyhidden--lap-and-up"><Link to="home">Home</Link></li>
          <li className="grid--order-2 visuallyhidden--lap-and-up"><Link to="brand">Brand</Link></li>
          <li className="grid--order-4 visuallyhidden--lap-and-up"><Link to="core">Core</Link></li>
          <li className="grid--order-6 visuallyhidden--lap-and-up"><Link to="components">Components</Link></li>
          <li className="grid--order-8 visuallyhidden--lap-and-up"><Link to="layouts">Layouts</Link></li>
          <li className="grid--order-8 visuallyhidden--lap-and-up"><Link to="themes">Themese</Link></li>
          <li className="grid--order-10 visuallyhidden--lap-and-up"><Link to="getting-started">Getting Started</Link></li>
          {this.renderSubMenu(sections, order, this.props.staticVersion)}
        </ul>

      </nav>
    )
  }
}

export default Sidebar



// WEBPACK FOOTER //
// ./styleguide/components/Sidebar.js